import {BsChatDots, BsCheck, BsCircle, BsDatabase, BsPen, BsPieChart, BsShield} from 'react-icons/bs'
import Panel from "Assets/Images/Panel.png"
import { Badge } from 'react-bootstrap'
import { MdRefresh } from 'react-icons/md'
import Tags from '../Tags/Tags'
export default function Products() {
  return (
    <div className='container' id="platform">
        <div className='row align-items-center'>
            <div className='col-md-6 p-4'>
                <div className='d-flex flex-row justify-content-center align-items-center'>
                    <h3 className='bold brand-p'>هوش مصنوعی ابن سینا</h3>    
                    
                </div>
                <hr/>
                <h5 className='text-center'>هوشمندسازی مدیریت منابع و فرایندهای سازمانی</h5>
                <br/>
                <div>
                    <img
                    width={"100%"}
                    src={Panel}/>
                </div>
                <br/>
                <p className='bold'>
                    <span className='text-primary m-2'><BsCheck size={"25px"}/></span>
                    هوشمندانه تصمیم میگیرند
                </p>
                <p className='bold'>
                    <span className='text-primary m-2'><BsCheck size={"25px"}/></span>
                    عملکرد حرفه ای دارند
                </p>
                <p className='bold'>
                    <span className='text-primary m-2'><BsCheck size={"25px"}/></span>
                    هزینه های پرسنلی شما را به حداقل میرسانند
                </p>
                
                <p className='brand-p text-secondary bold ' hidden>پلتفرمی یکپارچه جهت مدیریت منابع و فرایندهای سازمانی، بوسیله ی انجام عملیات توسط عامل های هوشمند و قابلیت تطبیق دقیق بر نیازمندهای خاص هر مجموعه.</p>
                <br/>
            <div className='row justify-content-center'>
                <div className='col-5 p-2'>
                    <a href='https://ble.ir/ibinsina_support'>
                        <button className='btn btn-outline-dark w-100 bold'>
                        مشاوره رایگان
                        </button>
                    </a>
                </div>
                <div className='col-5 p-2'>
                    <a href='https://panel.ibinsina.com'>
                        <button className='btn btn-primary w-100 bold '>ورود | ثبت نام</button>
                    </a>
                </div>  
            </div>
            </div>
            <div className='col-md-6 p-2'>
                <div>
                    <h5 className='bold'>
                        <span className='m-2 text-primary'><BsPieChart size={"20px"}/></span>
                        فروش هوشمند و پیگیری مشتریان
                    </h5>
                    <p className='brand-p'>از تولید سرنخ تا زمان بستن قرارداد را می‌توانند کامل مدیریت کنند. با پیگیری هوشمند، نرخ تبدیل فروش به‌صورت محسوسی افزایش پیدا می‌کند.</p>
                </div>
                <hr/>
                <div>
                    <h5 className='bold'>
                        <span className='m-2 text-primary'><MdRefresh size={"20px"}/></span>
                        مدیریت و اجرای وظایف اداری
                    </h5>
                    <p className='brand-p'>مانند ثبت داده‌ها، هماهنگی جلسات، ارسال ایمیل‌ها و گزارش‌های روزانه را به‌طور کامل اتومات می‌کنند.این باعث می‌شود پرسنل روی کارهای خلاقانه‌تر و با ارزش افزوده بیشتر تمرکز کنند.</p>
                </div>
                <hr/>
                <div>
                    <h5 className='bold'>
                        <span className='m-2 text-primary'><BsChatDots size={"20px"}/></span>
                        پشتیبانی و پاسخ‌گویی حرفه ای و مستمر
                    </h5>
                    <p className='brand-p'>عامل‌های هوشمند می‌توانند به‌صورت دائم به مشتریان پاسخ دهند و مشکلات را لحظه‌ای حل کنند. این کار فشار تیم پشتیبانی را کم کرده و سرعت ارائه خدمات را چند برابر می‌کند.</p>
                </div>
                <hr/>
                <div>
                    <h5 className='bold'>
                        <span className='m-2 text-primary'><BsPen size={"20px"}/></span>
                        تولید و مدیریت محتوای شبکه های اجتماعی
                    </h5>
                    <p className='brand-p'>عامل‌های هوشمند می‌توانند متن، پست شبکه‌های اجتماعی، ایمیل‌های بازاریابی و حتی ایده‌های کمپین تولید کنند. این کار باعث می‌شود تیم مارکتینگ سریع‌تر محتوا تولید کند و حضور آنلاین برند همیشه فعال بماند.</p>
                </div>
                 <hr/>
                <div>
                    <h5 className='bold'>
                        <span className='m-2 text-primary'><BsDatabase size={"20px"}/></span>
                        تحلیل داده های کسب و کار و تصمیم‌سازی سریع
                    </h5>
                    <p className='brand-p'>عامل‌ها می‌توانند داده‌های پیچیده را در لحظه تحلیل کرده و پیشنهادهای عملی ارائه دهند. این کار سرعت تصمیم‌گیری را بالا برده و خطاهای انسانی را کاهش می‌دهد.</p>
                </div>
                <Tags/>
            </div>
        </div>
    </div>
  )
}
